import { FC, Link, MouseEventHandler} from 'external/react'
import Icon from 'external/fortawesome'
import CourseCover from 'components/CourseCover'

type SelectedCourseProps = {
    id: string,
    index: number,
    language: 'en' | 'es'
    type: string,
    subject: string,
    offer: string
    onRemoveCourse: MouseEventHandler<HTMLSpanElement>
}

const SelectedCourse: FC<SelectedCourseProps> = props => {

	const { id, index, type, language, subject, offer, onRemoveCourse} = props

    return (
        <div className='course'>
            <Link to={`/course-detail/${id}`}>
                <div className='courseContent'>
                    <CourseCover id={id} />
                </div>
            </Link>
            <div className='containerSelectedFooter'>
                <div className='actions'>
                    <span>
                        <Link to={{ pathname: `/courses/${subject}/${offer}/${index}/${type}`, search: `?languageId=${language}`, }} >
                            <Icon name='faPenToSquare' color='#1797D0' className='px-1' title='editar' />
                        </Link>
                    </span>
                    <span onClick={onRemoveCourse}>
                        <Icon name='faTrashCan' color='#FF5E5E' className='px-1' title='eliminar' />
                    </span>
                </div>
            </div>
        </div>
    )
}

export {SelectedCourse as default}